import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ypfapuzkuvpkyfjabjgi.supabase.co'
const supabaseKey = 'sb_publishable_VXP0-IThH_WhQfqkwGYshg_aXrkQr2s'

export const supabase = createClient(supabaseUrl, supabaseKey)
